import { useEffect, useState } from 'react'
import { useAuthContext } from '../context/AuthContext'

const useConsultantInfo = () => {
  const [consultantInfo, setConsultantInfo] = useState(null)
  const { state } = useAuthContext()

  useEffect(() => {
    // Ensure window is available before accessing sessionStorage
    if (typeof window !== 'undefined') {
      const consultantInfoString =
        window.sessionStorage.getItem('consultantInfo')
      const storedConsultantInfo = consultantInfoString
        ? JSON.parse(consultantInfoString)
        : null

      if (storedConsultantInfo) {
        setConsultantInfo(storedConsultantInfo)
      }
    }
  }, [])

  useEffect(() => {
    // Event listener for 'zipcodeSent'
    const handleZipcodeSent = (event) => {
      if (event?.detail) {
        setConsultantInfo(event.detail)
      }
    }

    // Ensure document is available before adding event listener
    if (typeof document !== 'undefined') {
      document.addEventListener('zipcodeSent', handleZipcodeSent)
    }

    return () => {
      // Cleanup event listener on unmount
      if (typeof document !== 'undefined') {
        document.removeEventListener('zipcodeSent', handleZipcodeSent)
      }
    }
  }, [])

  return [consultantInfo, setConsultantInfo]
}

export default useConsultantInfo
